import React, { useState, useEffect } from "react";
import { TileBox } from "./Tile.styled";

export default function Tile(props) {
  // eslint-disable-next-line
  const [rotate, setRotate] = useState("0deg");
  useEffect(()=>{
    setRotate(props.rotate || "0deg")
  },[])
  return (
    <TileBox
      position={props.position}
      onClick={() => props.changePosition(props.number)}
      bg={props.bg}
      rotate={rotate}
      className="tile"
      
    >
      {props.image && <img src={props.image} alt="tile" draggable={false} />}
    </TileBox>
  );
}
